// Author: ForgeVector Software Limited.
// Shopify Cookie Banner API: https://shopify.dev/docs/api/customer-privacy#cookie-banner-api
// Reopen the configured native banner. Consent remains under the customer's control.
(() => {
  const failure = 'Cookie settings could not open. Refresh this page and try again.';
  const waitForBanner = async () => {
    for (let attempt = 0; attempt < 12; attempt++) {
      if (typeof window.privacyBanner?.showPreferences === 'function') return window.privacyBanner;
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    throw new Error('Shopify cookie settings unavailable');
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-settings]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) { status.textContent = ''; status.hidden = true; }
    let timeout;
    try {
      const banner = await waitForBanner();
      await Promise.race([
        banner.showPreferences(),
        new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Cookie settings timed out')), 8000); })
      ]);
    } catch {
      if (status) { status.textContent = failure; status.hidden = false; }
    } finally {
      clearTimeout(timeout);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
